/**
 * @file IconTimeFill Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-time-fill',
  (data) => `
<svg width="${data.size}" height="${data.size}" fill="none" viewBox="0 0 60 60">
  <g>
    <path
      fill="${data.colorDesc[0]}"
      fill-opacity="1"
      d="M30,0C13.4464,0,0,13.4464,0,30C0,46.5536,13.4464,60,30,60C46.5536,60,60,46.5536,60,30C60,13.4464,46.5536,0,30,0ZM42.8036,40.4464L28.4464,32.1429L27.8571,32.1429L27.8571,12.8571L32.1429,12.8571L32.1429,29.3571L44.9464,36.75L42.8036,40.4464Z"
    />
  </g>
</svg>
`
);
